import PropTypes from 'prop-types';
import * as Icons from './Icons';

const Icon = ({ id, icon, theme, size, style, className }) => {
  const styles = require('./Icon.module.scss');

  const viewBoxMap = {
    SOCIAL_X: '0 0 14 14',
    SOCIAL_LINK: '0 0 18 18',
    SOCIAL_SPOTIFY: '0 0 16 16',
    SOCIAL_PODCAST: '0 0 16 16',
    ACTION_CHEVRON_DOWN: '0 0 14 8',
  };

  const viewBox = viewBoxMap[icon] || '0 0 58 58';

  return (
    <div
      id={id}
      className={!className ? styles[theme] : className}
      style={{ width: size, height: size, verticalAlign: 'middle', ...style }}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox={viewBox}
        style={{ width: size, height: size, verticalAlign: 'middle' }}
        className={styles.Icon}>
        {Icons[icon]}
      </svg>
    </div>
  );
};

Icon.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  theme: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default Icon;
